import { BroadcastChannel as i } from "broadcast-channel";
import { SIRONA_BROADCAST_CHANNEL as n } from "../constants/crossTabEvents.js";
import { emitter as e } from "./emitter.js";
async function A(t, r) {
  if (!t) return;
  const o = new i(n);
  e.emit(t, r), await o.postMessage({
    namespace: t,
    payload: r
  });
}
export {
  A as sendCrossTabEvent
};
//# sourceMappingURL=sendCrossTabEvent.js.map
